import { normalizeLocale } from "../translate.js";
import { visualGuidesEn } from "./en.js";
import { visualGuidesNl } from "./nl.js";
import { buildGuideSketches } from "./sketches.js";

/** @type {Record<string, import("./types.js").VisualGuidesCatalog>} */
const VISUAL_GUIDES_BY_LOCALE = {
  nl: visualGuidesNl,
  en: visualGuidesEn,
};

/**
 * @param {string} [locale]
 * @returns {import("./types.js").VisualGuidesCatalog}
 */
export function buildVisualGuides(locale) {
  const normalized = normalizeLocale(locale);
  return VISUAL_GUIDES_BY_LOCALE[normalized] ?? visualGuidesNl;
}

export { buildGuideSketches };
